/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte Carlo simulation with 10,000 scenarios to account for uncertainty in race outcomes`)
};

const es_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulación Monte Carlo con 10,000 escenarios para considerar la incertidumbre en resultados de carrera`)
};

const de_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte-Carlo-Simulation mit 10.000 Szenarien zur Berücksichtigung der Unsicherheit bei Rennergebnissen`)
};

const nl_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte Carlo-simulatie met 10.000 scenario's om onzekerheid in race-uitkomsten mee te nemen`)
};

const fr_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulation Monte Carlo avec 10 000 scénarios pour tenir compte de l’incertitude des résultats de course`)
};

const it_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulazione Monte Carlo con 10.000 scenari per tenere conto dell’incertezza nei risultati delle gare`)
};

const pt_br2_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulação Monte Carlo com 10.000 cenários para considerar incerteza nos resultados das corridas`)
};

const pt_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simulação Monte Carlo com 10.000 cenários para considerar a incerteza nos resultados das corridas`)
};

const ja_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レース結果の不確実性を考慮したモンテカルロシミュレーション（10,000シナリオ）`)
};

const zh_about_optimizer_li4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10,000次蒙特卡罗模拟，以考虑比赛结果的不确定性`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_optimizer_li4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_optimizer_li4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_optimizer_li4", locale)
	if (locale === "en") return en_about_optimizer_li4(inputs)
	if (locale === "es") return es_about_optimizer_li4(inputs)
	if (locale === "de") return de_about_optimizer_li4(inputs)
	if (locale === "nl") return nl_about_optimizer_li4(inputs)
	if (locale === "fr") return fr_about_optimizer_li4(inputs)
	if (locale === "it") return it_about_optimizer_li4(inputs)
	if (locale === "pt-BR") return pt_br2_about_optimizer_li4(inputs)
	if (locale === "pt") return pt_about_optimizer_li4(inputs)
	if (locale === "ja") return ja_about_optimizer_li4(inputs)
	return zh_about_optimizer_li4(inputs)
};